import React from 'react';
import './App.css';
import './OrganizationSt.css';

export default function OrganizationSt({ onBackClick }) {
  return (
    <main className="page-content about-overview" style={{ padding: '28px 16px', paddingBottom: '180px', maxWidth: 1100, margin: '0 auto', position: 'relative' }}>
      <button
        className="back-button"
        onClick={() => onBackClick && onBackClick('home')}
        style={{
          backgroundColor: '#0b6b2f',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        ← ආපසු
      </button>

      <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>අපගේ සංවිධාන ව්‍යුහය</h1>
      <hr className="footer-sep" />

      <div className="organizationst-wrapper">
        <img src="/organizationst.jpg" alt="organization structure" className="organizationst-image" />
      </div>
    </main>
  );
}